export const GET_TODO = "todos";
export const LOGIN_URL = "login";
export const MASTER_SCHEDULE_CSV_DOWNLOAD = "masterSchedule/csvReport";
